import * as React from "react"
export const Svg_067 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M0 38.542h45.873v4.61H0v-4.61Z" />
    <path
      fill="url(#b)"
      d="M20.857 47.185a2.884 2.884 0 0 1-2.88 2.88h-3.838v3.458h30.722v-3.457h-3.838a2.884 2.884 0 0 1-2.88-2.881v-.576H20.857v.576Z"
    />
    <path fill="url(#c)" d="M0 5.477h59v4.61H0v-4.61Z" />
    <path
      fill="url(#d)"
      d="M0 13.544v21.541h59V13.544H0ZM18.913 29.5h-3.457v-3.457h3.457V29.5Zm0-6.914h-3.457v-3.457h3.457v3.457Zm24.63 6.914H22.37v-3.457h21.174V29.5ZM22.37 22.586v-3.457h21.174v3.457H22.37Z"
    />
    <path fill="url(#e)" d="M49.33 38.542H59v4.61h-9.67v-4.61Z" />
    <defs>
      <linearGradient
        id="a"
        x1={10.608}
        x2={10.911}
        y1={39.234}
        y2={44.111}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={21.244}
        x2={22.246}
        y1={47.646}
        y2={54.851}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={13.644}
        x2={13.88}
        y1={6.169}
        y2={11.053}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.644}
        x2={18.556}
        y1={16.775}
        y2={38.549}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={51.566}
        x2={52.893}
        y1={39.234}
        y2={43.739}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)